<template>
    <Dropdown class="dropdown-selection--section section-nav">
        <div class="dropdown-selection" href="javascript:void(0)" data-testid="section-nav__selector">
            {{ getCurrentPage }}
            <Icon v-if="campaignId" class="dropdown-selection-icon" type="ios-arrow-down" />
        </div>
        <template #list>
            <DropdownMenu v-if="campaignId" data-testid="section-nav__selector--menu">
                <DropdownItem>
                    <router-link
                        :to="{
                            name: AppRouteNames.CAMPAIGN_EDITOR,
                            params: { clientId: clientId, campaignId: campaignId }
                        }"
                        data-testid="section-nav__editor"
                    >
                        Assemble
                    </router-link>
                </DropdownItem>
                <DropdownItem>
                    <router-link
                        :to="{
                            name: AppRouteNames.CAMPAIGN_LIBRARY,
                            params: { clientId: clientId, campaignId: campaignId }
                        }"
                        data-testid="section-nav__library"
                    >
                        Creative Library
                    </router-link>
                </DropdownItem>
                <DropdownItem v-if="clientHasConnectEnabled">
                    <router-link
                        :to="{
                            name: AppRouteNames.CAMPAIGN_CONNECT,
                            params: { clientId: clientId, campaignId: campaignId }
                        }"
                        data-testid="section-nav__intelligent-delivery"
                    >
                        Connect
                    </router-link>
                </DropdownItem>
            </DropdownMenu>
        </template>
    </Dropdown>
</template>

<script lang="ts">
import { AppRouteNames } from "@/router/constants";

export default {
    name: "SectionNav",

    props: {
        isAuthorizedContentVisible: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            AppRouteNames
        };
    },

    computed: {
        clientId() {
            return this.$route.params.clientId;
        },

        campaignId() {
            return this.$route.params.campaignId;
        },

        getCurrentPage() {
            switch (this.$route.name) {
                case AppRouteNames.CAMPAIGN_LIBRARY:
                    return "Creative Library";
                case AppRouteNames.CAMPAIGN_EDITOR:
                    return "Assemble";
                case AppRouteNames.CAMPAIGN_CONNECT:
                    return "Connect";
                default:
                    return "Assemble";
            }
        },

        clientHasConnectEnabled() {
            if (this.$store.state.ui.currentClient) {
                return this.$store.state.ui.currentClient.connectModuleEnabled;
            }

            return false;
        }
    }
};
</script>
